import React, { useEffect, useState } from "react";
import { useAxiosContext } from "../../../context/AxiosContext";
import { useParams } from "react-router-dom";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import OwnerAssignment from "../../StateMachine/OwnerAssignment";
import { useFormContext } from "../../../context/FormContext";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import OwnerAssignmentCard from "../../StateMachine/OwnerAssignmentCard";

const RdbmsSettings = () => {
  const { axiosInstance } = useAxiosContext();
  const { rdbmsConfig, setRdbmsConfig } = useFormContext();

  const [allGroups, setAllGroups] = useState([]);
  // const [allCommunityGroups, setAllCommunityGroups] = useState([]);

  const [isRightbarOpen, setIsRightbarOpen] = useState(false);

  const { orgId } = useParams();

  const settingOwnerAssignment = (data) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      owner_assignment: {
        ...prev.owner_assignment,
        ...data
      }
    }));
  };

  const fetchAllGroups = async () => {
    try {
      const { data: groups } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
      // const { data: commGroups } = await axiosInstance.get(`/community-user-groups`);
      setAllGroups(groups);
      // setAllCommunityGroups(commGroups);
    } catch (error) {
      console.error("Error fetching all groups:", error);
    }
  };

  useEffect(() => {
    fetchAllGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sm_inner_left" style={{ height: "calc(100vh - 136px)", width: "600px", margin: "auto" }}>
      <div className="owner_assignment_container">
        <div style={{ position: "relative" }}>
          <div
            className="activity_select_top_block builder_form"
            style={{ width: "100%", margin: "53px auto 20px auto" }}
          >
            <label className="section_sub_heading">Owner Assignment</label>
            <div className="form_edit_del_buttons">
              <button
                className="builder_action_btn  edit"
                title=""
                style={{ width: "32px", height: "32px", fontsize: "20px" }}
                onClick={() => setIsRightbarOpen(true)}
              >
                <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
              </button>
            </div>
            <div className="overlay_cover"></div>
            <OwnerAssignmentCard
              ownerAssignment={rdbmsConfig?.owner_assignment}
              allGroups={allGroups}
              // allCommunityGroups={allCommunityGroups}
            />
          </div>
        </div>
      </div>
      <BuilderRightSideBar isOpen={isRightbarOpen} heading="Owner Assignment" onClose={(res) => setIsRightbarOpen(res)}>
        <OwnerAssignment ownerAssignment={rdbmsConfig?.owner_assignment} setOwnerAssignment={settingOwnerAssignment} />
      </BuilderRightSideBar>
    </div>
  );
};

export default RdbmsSettings;
